import "./global.css";
import { SimpleKitContextProvider } from "./context/SimpleKitContext";
import { SimpleKitModalProvider } from "./web3kit";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

export { useSimpleKit } from "./context/SimpleKitContext";
export {
  useAccount,
  useChainInfo,
  useBalance,
  useTokenBalance,
  useBalanceAsync,
  useSignMessageAsync,
  useSignTypedDataAsync,
  useTokenBalanceAsync,
  useDisconnectAccount,
  useReadContractAsync,
  useWriteContractAsync,
} from "./hooks";

export function SimpleKitProvider({
  chains,
  etherWalletConnector,
  solanaWalletConnector,
  children,
  signMessage,
  metadata,
  queryClient,
  projectId,
}: {
  chains: any;
  etherWalletConnector: any;
  solanaWalletConnector: any;
  signMessage: string;
  children: any;
  metadata: any;
  queryClient: QueryClient;
  projectId: string;
}) {
  return (
    <QueryClientProvider client={queryClient}>
      <SimpleKitContextProvider
        chains={chains}
        metadata={metadata}
        projectId={projectId}
        signMessage={signMessage}
      >
        <SimpleKitModalProvider>{children}</SimpleKitModalProvider>
      </SimpleKitContextProvider>
    </QueryClientProvider>
  );
}
